module.exports = __webpack_public_path__ + "static/web_development-27908aeee3c22f9bff0d9294ed8fadba.svg";